import { render, staticRenderFns } from "./EditAffiliateCompany.vue?vue&type=template&id=51279bb3&"
import script from "./EditAffiliateCompany.vue?vue&type=script&lang=js&"
export * from "./EditAffiliateCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports